import { Component } from '@angular/core';

@Component({
  selector: 'app-dealersidebar',
  templateUrl: './app-dealersidebar.component.html'
})
export class AppDealersidebarComponent { }



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-dealersidebar/app-dealersidebar.component.ts